/* @flow */

import PictureLoader from "./PictureLoader";

export type { ResponsiveImageSet } from "./PictureLoader";
export default PictureLoader;
